import ApiService from "@/common/services/http/api.service";

const GrupoDocumentoUsuarioService = {
  /**
   * Buscar os departamentos por clientes
   * @param clienteID id do cliente
   * @returns {*}
   */
  async getGrupoDocumentoUsuarioByGrupoDocumentoID(grupoDocumentoID) {
    const { data: result } = await ApiService.get(
      "GrupoDocumentoUsuario/getbyGrupoDocumentoID",
      grupoDocumentoID
    );

    return result;
  },
  async save(grupoDocumentoUsuario) {
    const { data: result } = await ApiService.post(
      "GrupoDocumentoUsuario/salvarRange",
      grupoDocumentoUsuario
    );

    return result;
  },
};

export default GrupoDocumentoUsuarioService;
